import { Routes } from '@angular/router';
import {authGuard} from './guards/auth.guard';
import {LayoutComponent} from '@components/layout/layout.component';
import {LoginComponent} from '@components/login/login.component';
import { RequestFormComponent } from "@components/request-form/request-form.component";
import {ProceduresComponent} from '@components/procedures/procedures.component';
import {ImsComponent} from '@components/ims/ims.component';
import {MyRequestsComponent} from '@components/my-requests/my-requests.component';
import {ProcedureComponent} from '@components/procedure/procedure.component';
import {RequestComponent} from '@components/request/request.component';
import {ImsDetailComponent} from '@components/ims-detail/ims-detail.component';
import {MsalRedirectComponent} from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: MyRequestsComponent },
      { path: 'modulo-di-richiesta', component: RequestFormComponent },
      { path: 'atti-amministrativi', component: ProceduresComponent },
      { path: 'atti-amministrativi/:id', component: ProcedureComponent },
     /* { path: 'comunicazioni/:id', component: ProcedureComponent },
      { path: 'comunicazioni', component: ProceduresComponent },*/
      { path: 'richiesta/:id', component: RequestComponent },
      { path: 'documenti-sgi', component: ImsComponent },
      { path: 'documenti-sgi/:id', component: ImsDetailComponent },
    ]
  },
  {
    path: 'login',
    component: LoginComponent,
    /*canActivate: [authGuard],*/
  },
  { path: '**', redirectTo: '' } // Fallback
];
